<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          ref="date"
          v-model="tempDate"
          :prepend-icon="icon"
          readonly
          v-on="on"
          :label="label ? label : ''"
          :background-color="background ? background : ''"
          :hideDetails="hideDetails"
          :dense="dense"
          :clearable="clearable"
          :disabled="disabled"
          @click:clear="onClear()"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="tempDate"
        scrollable
        :no-title="title"
        locale="ja-jp"
        :day-format="date => new Date(date).getDate()"
        @input="onUpdated(), menu = false"
        :disabled="disabled"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tempDate: null,
      menu: false,
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  props: [ 'id', 'date', 'icon', 'label', 'title', 'background', 'validate', 'hideDetails', 'dense', 'clearable', 'disabled' ],
  created () {
    this.onInit()
  },
  watch: {
    date () {
      this.onInit()
    },
    validate () {
      if (this.validate) {
        this.$refs.date.validate(true)
      } else {
        this.$refs.date.validate(false)
      }
    }
  },
  methods: {
    onClear () {
      this.tempDate = null
      this.$emit('updated', { id: this.id, date: this.tempDate })
    },
    onUpdated () {
      this.$emit('updated', { id: this.id, date: this.tempDate })
      this.menu = false
    },
    onInit () {
      this.tempDate = this.date ? JSON.parse(JSON.stringify(this.date)) : null
    }
  }
}
</script>

<style>
</style>
